// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block":"block_q79L+","title":"title_apq-z"};